import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationMap = () => {
  const locationDetails = [
    {
      icon: 'MapPin',
      title: 'Alamat Lengkap',
      content: 'Jl. Benda Raya, Pd. Benda, Kec. Pamulang, Kota Tangerang Selatan, Banten 15416',
    },
    {
      icon: 'Clock',
      title: 'Jam Operasional',
      content: 'Senin - Minggu: 08:00 - 20:00 WIB\nMinggu & Libur Nasional: 08:00 - 15.00 WIB',
    },
    {
      icon: 'Car',
      title: 'Fasilitas Parkir',
      content: 'Parkir luas untuk mobil & motor\nArea parkir aman dan nyaman',
    },
  ];

  return (
    <section id="location" className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12 lg:mb-16" data-aos="fade-up" data-aos-delay="150">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            Lokasi Showroom
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Kunjungi showroom Honda Pamulang untuk pengalaman langsung dengan produk kami
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12" >
          <div className="space-y-4 md:space-y-6">
            {locationDetails?.map((detail, index) => (
              <div
                key={index}
                className="bg-card rounded-xl p-4 md:p-6 border border-border hover:shadow-card-hover transition-all duration-300"
                data-aos="fade-right" data-aos-delay="150"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={detail?.icon} size={24} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
                      {detail?.title}
                    </h3>
                    <p className="text-sm md:text-base text-muted-foreground leading-relaxed whitespace-pre-line">
                      {detail?.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            <div className="bg-gradient-to-br from-primary to-accent rounded-xl p-6 md:p-8 text-white">
              <div className="flex items-start space-x-4 mb-4 md:mb-6" data-aos="fade-down" data-aos-delay="150">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
                  <Icon name="Headphones" size={24} color="white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-heading font-bold mb-2">
                    Butuh Bantuan Arah?
                  </h3>
                  <p className="text-sm md:text-base text-white/90 leading-relaxed">
                    Tim kami siap membantu memberikan panduan arah ke showroom
                  </p>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3" data-aos="fade-up" data-aos-delay="150">
                <a
                  href="https://wa.me/+6288293642972?text=Halo,%20saya%20butuh%20bantuan%20arah%20ke%20showroom%20Honda%20Pamulang"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 inline-flex items-center justify-center space-x-2 px-4 md:px-6 py-3 bg-white text-primary rounded-lg font-heading font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-300"
                >
                  <Icon name="MessageCircle" size={20} />
                  <span>Chat WhatsApp</span>
                </a>

                <a
                  href="tel:+6288293642972"
                  className="flex-1 inline-flex items-center justify-center space-x-2 px-4 md:px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-lg font-heading font-semibold text-sm md:text-base hover:bg-white/20 transition-all duration-300 border border-white/30"
                >
                  <Icon name="Phone" size={20} />
                  <span>Telepon</span>
                </a>
              </div>
            </div>
          </div>

          <div className="space-y-4 md:space-y-6">
            <div className="bg-card rounded-xl overflow-hidden border border-border shadow-card-hover">
              <div className="aspect-[4/3] w-full" data-aos="fade-left" data-aos-delay="150">
                <iframe
                  title="Dealer Honda Berdikari Pamulang"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.470070247623!2d106.7071931745327!3d-6.333095761965408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69e5cbfa767641%3A0xa02148edb33d9f0d!2sDealer%20Honda%20Berdikari%20Pamulang!5e0!3m2!1sid!2sid!4v1768753923100!5m2!1sid!2sid"
                  className="w-full h-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>

              <div className="p-4 md:p-6 bg-muted">
                <div className="flex items-center justify-between" data-aos="fade-left" data-aos-delay="150">
                  <div>
                    <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
                      Honda Pamulang
                    </h4>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      Jl. Raya Pamulang No. 123
                    </p>
                  </div>

                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=Dealer+Honda+Berdikari+Pamulang"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg font-heading font-semibold text-sm hover:bg-accent transition-all duration-300"
                  >
                    <Icon name="Navigation" size={18} />
                    <span className="hidden sm:inline">Buka Maps</span>
                  </a>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 md:gap-4" data-aos="fade-up" data-aos-delay="150">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Dealer+Honda+Berdikari+Pamulang"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-card rounded-lg p-4 md:p-6 border border-border hover:shadow-card-hover transition-all duration-300 text-center group"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-blue-50 flex items-center justify-center mx-auto mb-3 group-hover:bg-blue-100 transition-colors">
                  <Icon name="Navigation" size={24} color="#3B82F6" />
                </div>
                <p className="text-xs md:text-sm font-heading font-semibold text-foreground">
                  Petunjuk Arah
                </p>
              </a>

              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Dealer+Honda+Berdikari+Pamulang"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-card rounded-lg p-4 md:p-6 border border-border hover:shadow-card-hover transition-all duration-300 text-center group"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-green-50 flex items-center justify-center mx-auto mb-3 group-hover:bg-green-100 transition-colors">
                  <Icon name="MapPin" size={24} color="#00B04F" />
                </div>
                <p className="text-xs md:text-sm font-heading font-semibold text-foreground">
                  Lihat di Maps
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;